import { schema } from 'normalizr';

import { processLeader } from '../strategies/leader';

import { userSchema } from './user';

export const leaderSchema: schema.Entity = new schema.Entity(
  'userNetworkLeaders',
  { id: userSchema },
  { processStrategy: processLeader }
);

export const leaderEdgesSchema: schema.Object[] = [new schema.Object({ node: leaderSchema })];
